import platform from 'platform'

const dmeta = document.querySelector('meta[name="tv:device"]')
const device = dmeta != null ? dmeta.getAttribute('content') : 'pc'
export const isPC = device === 'pc'
export const isSP = device === 'sp'

export const isIos = platform.os.toString().indexOf('iOS') >= 0
export const isIosChorome = isIos && platform.name.indexOf('Chrome') >= 0
export const isAndroid = platform.os.toString().indexOf('Android') >= 0
export const isIosOver9 = platform.manufacturer === 'Apple' && Number(platform.version.split('.').shift()) > 9
export const isMacSafari = platform.name === 'Safari' && platform.os.family === 'OS X'
export const isAndroidChrome =
  isAndroid && platform.name.toString().indexOf('Chrome') !== -1 && Number(platform.version.split('.').shift()) > 52
export const isEdge = platform.os.family === 'Windows' && platform.os.version === '10' && platform.name === 'Microsoft Edge'
export const isIE = platform.name === 'IE'
export const isIos10 = platform.os.toString().indexOf('iOS') >= 0 && Number(platform.version.split('.').shift()) === 10



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/VideoPlayer/utils/device.js